module.exports = __webpack_public_path__ + "static/media/heavy-bleeding-ON.3f7bda0f.png";